import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box } from '@quintoandar-tokko/jopijs';
import BaseModal from '../../BaseModal';
import {
  clearPerformanceModalFilters,
  setPerformanceModals,
} from '@/store/slices/components/dashboard/DashboardSlice';
import buildQuery from '@/components/Dashboard/utils/buildQuery';
import { getPerformanceResponseTimeTable } from '@/store/slices/components/dashboard/service';
import Trans from '@/components/shared/Trans';
import translations from '@/components/Dashboard/Dashboard.trans.json';
import DownloadButton from '@/components/Dashboard/DashboardTables/components/DownloadButton';
import styles from '../../performanceModals.module.scss';
import buildTableQuery from '@/components/Dashboard/utils/buildTableQuery';
import useAsyncTableExcelDownload from '@/components/Dashboard/customHooks/useAsyncTableExcelDownload';
import { TABLES } from '@/components/Dashboard/constants';
import TableSearchEmptyState from '@/components/Dashboard/DashboardTables/TableSearchEmptyState';
import SearchInput from '../../SearchInput';
import { responseTimeTypesOptions } from '../utils';
import ResponseTimeTable from '@/components/Dashboard/DashboardTables/ResponseTimeTable';
import { AGENT } from '@/components/FilterBar/constants/filtersConstants';
import useTrackPerformanceTable from '@/components/Dashboard/customHooks/useTrackDashboard';
import { TRACK_ELEMENT } from '@/components/Dashboard/constants/track';

export default function ResponseTimeModal() {
  const dispatch = useDispatch();
  const { selectedIds } = useSelector((state) => state.FilterBarSlice.filters);
  const { responseTime } = useSelector(
    (state) => state.DashboardSlice.performanceModals
  );
  const {
    list,
    loading,
    sortBy,
    sortDirection,
    searchQuery,
    searchTypeFlag,
    median_response_time,
  } = responseTime;
  const track = useTrackPerformanceTable();
  const { handleDownloadExcel: downloadExcel, isDownloading } =
    useAsyncTableExcelDownload(TABLES.RESPONSE_TIME);

  useEffect(() => {
    const fetchData = () => {
      const query = buildQuery(selectedIds);
      const tableQuery = buildTableQuery(responseTime);

      dispatch(getPerformanceResponseTimeTable({ query, tableQuery }));
    };

    fetchData();
  }, [sortBy, sortDirection, searchQuery, searchTypeFlag]);

  const handleDownloadExcel = () => {
    const query = buildQuery(selectedIds);
    const tableQuery = buildTableQuery(responseTime);
    downloadExcel(query, tableQuery);
    track.responseTime(TRACK_ELEMENT.DOWNLOAD_BUTTON);
  };

  const handleClearFilters = () => {
    const modal = 'responseTime';
    const filters = ['searchQuery', 'searchType'];
    dispatch(clearPerformanceModalFilters({ modal, filters }));
  };

  // Validate if filters haver 1 or more than 1 agent selected
  const agentsSelected = selectedIds.filter((x) => x?.filter_type === AGENT);

  return (
    <BaseModal
      id="response-time-modal"
      title={`${Trans(translations, 'MedianResponseTime')}: ${
        median_response_time ?? '0'
      }`}
      handleClose={() =>
        dispatch(
          setPerformanceModals({
            key: 'responseTime',
            subkey: 'isOpen',
            value: false,
          })
        )
      }
    >
      <Box className={styles.modalControls}>
        <SearchInput
          modal="responseTime"
          dropdownOptions={
            agentsSelected.length === 1 ? responseTimeTypesOptions : []
          }
        />

        <DownloadButton
          onClick={handleDownloadExcel}
          disabled={isDownloading}
        />
      </Box>
      {searchQuery && list?.length === 0 && !loading ? (
        <TableSearchEmptyState onClearFilters={handleClearFilters} />
      ) : (
        <BaseModal.TableContainer>
          <ResponseTimeTable />
        </BaseModal.TableContainer>
      )}
    </BaseModal>
  );
}
